"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinEntry = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("../common");
var PinEntry;
(function (PinEntry) {
    function timeSpent(entry) {
        if (!lodash_1.default.isNil(entry.timeSpent))
            return entry.timeSpent;
        // realtime
        const seenAt = entry.seenAt;
        if (seenAt && entry.answer && entry.answer.modifiedAt) {
            return entry.answer.modifiedAt - seenAt;
        }
        return 0;
    }
    PinEntry.timeSpent = timeSpent;
    function isDone(entry) {
        return !!entry.done;
    }
    PinEntry.isDone = isDone;
    function isOpenQuestion(entry) {
        return entry.type == 'OPEN_QUESTION';
    }
    PinEntry.isOpenQuestion = isOpenQuestion;
    function areOpenQuestions(entries) {
        return lodash_1.default.every(entries, (entry) => isOpenQuestion(entry));
    }
    PinEntry.areOpenQuestions = areOpenQuestions;
    function isWordCloud(entry) {
        return entry.type == 'WORD_CLOUD';
    }
    PinEntry.isWordCloud = isWordCloud;
    function areWordClouds(entries) {
        return lodash_1.default.every(entries, (entry) => isWordCloud(entry));
    }
    PinEntry.areWordClouds = areWordClouds;
    function isQuizQuestion(entry) {
        return entry.type == 'MULTIPLE_CHOICE';
    }
    PinEntry.isQuizQuestion = isQuizQuestion;
    function areQuizQuestions(entries) {
        return lodash_1.default.every(entries, (entry) => isQuizQuestion(entry));
    }
    PinEntry.areQuizQuestions = areQuizQuestions;
    function isDragQuestion(entry) {
        return entry.type == 'DRAG_QUESTION';
    }
    PinEntry.isDragQuestion = isDragQuestion;
    function areDragQuestions(entries) {
        return lodash_1.default.every(entries, (entry) => isDragQuestion(entry));
    }
    PinEntry.areDragQuestions = areDragQuestions;
    function isMap(entry) {
        return entry.type == 'MAP';
    }
    PinEntry.isMap = isMap;
    function areMaps(entries) {
        return lodash_1.default.every(entries, (entry) => isMap(entry));
    }
    PinEntry.areMaps = areMaps;
    function isSlide(entry) {
        return entry.type == 'SLIDE';
    }
    PinEntry.isSlide = isSlide;
    function areSlides(entries) {
        return lodash_1.default.every(entries, (entry) => isSlide(entry));
    }
    PinEntry.areSlides = areSlides;
    function isVideo(entry) {
        return entry.type == 'VIDEO';
    }
    PinEntry.isVideo = isVideo;
    function areVideos(entries) {
        return lodash_1.default.every(entries, (entry) => isVideo(entry));
    }
    PinEntry.areVideos = areVideos;
    function isLink(entry) {
        return entry.type == 'LINK';
    }
    PinEntry.isLink = isLink;
    function areLinks(entries) {
        return lodash_1.default.every(entries, (entry) => isLink(entry));
    }
    PinEntry.areLinks = areLinks;
    function isInteractive(entry) {
        return !!entry && common_1.PinUtils.typeIsInteractive(entry.type);
    }
    PinEntry.isInteractive = isInteractive;
    function create(pin) {
        return {
            pinId: pin._id,
            type: pin.type,
        };
    }
    PinEntry.create = create;
    function commentAndSeenDateForPinEntry(entry) {
        return entry.comment ? { comment: entry.comment, commentSeenAt: entry.commentSeenAt } : undefined;
    }
    PinEntry.commentAndSeenDateForPinEntry = commentAndSeenDateForPinEntry;
    function hasUnseenComment(entry) {
        const commentData = commentAndSeenDateForPinEntry(entry);
        return !!(commentData && commentData.comment && !commentData.commentSeenAt);
    }
    PinEntry.hasUnseenComment = hasUnseenComment;
    function groupByType(enties) {
        const entryGroupByType = {
            map: [],
            link: [],
            slide: [],
            video: [],
            openQuestion: [],
            question: [],
            dragQuestion: [],
            wordCloud: [],
        };
        enties.forEach((entry) => {
            if (isMap(entry))
                entryGroupByType.map.push(entry);
            else if (isLink(entry))
                entryGroupByType.link.push(entry);
            else if (isSlide(entry))
                entryGroupByType.slide.push(entry);
            else if (isVideo(entry))
                entryGroupByType.video.push(entry);
            else if (isOpenQuestion(entry))
                entryGroupByType.openQuestion.push(entry);
            else if (isQuizQuestion(entry))
                entryGroupByType.question.push(entry);
            else if (isDragQuestion(entry))
                entryGroupByType.dragQuestion.push(entry);
            else if (isWordCloud(entry))
                entryGroupByType.wordCloud.push(entry);
        });
        return entryGroupByType;
    }
    PinEntry.groupByType = groupByType;
})(PinEntry || (exports.PinEntry = PinEntry = {}));
//# sourceMappingURL=PinEntry.js.map